var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"overflow-auto",style:({height: _vm.getTemplateHeight.px}),on:{"resize":_vm.layoutTemplateResize}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }